export default __webpack_public_path__ + "static/media/web.128f067b.config";